import { Box, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import InlineText from '../../../Common/InlineText';
import { getNameFromList } from '..';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  bottomSubmit: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
}))

const GRID_SPACE = 2;

function ReviewSummary(props) {
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  const { data, statusList } = props;
  const { reviewTypeList } = statusList;

  const deductionStatus = [
    {
      id: 1,
      text: t('no_deduction'),
      value: 0
    },
    {
      id: 2,
      text: t('deducted'),
      value: 1
    }
  ];

  function getdedectionName(deductionStatus, value) {
    const status = deductionStatus.find((status) => status.value === value);
    return status ? status.text : '';
  }

  return (
    <Box>
      <Grid container spacing={GRID_SPACE} className={classes.section}>
        <Grid item xs={12}>
          <InlineText
            title={t('reviewed_confirmed')}
            text={getNameFromList(reviewTypeList, data.review_type)}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText
            title={t('consignee_refund')}
            text={getdedectionName(deductionStatus, data.consignee_refund)}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText
            title={t('client_refund')}
            text={getdedectionName(deductionStatus, data.client_refund)}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('close_time')}
            text={moment.unix(data.close_time).format("YYYY-MM-DD")}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('notes')}
            text={data.notes}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReviewSummary